import { Action } from '@reduxjs/toolkit';
import * as Actions from '~/actions';

export const getReferenceData = (): Action => {
	return { type: Actions.REFERENCE_DATA_GET_REQUESTED };
}

export const getStorageAccessSignature = (): Action => {
	return { type: Actions.REFERENCE_GET_STORAGE_ACCESS_SIGNATURE_REQUESTED };
}